var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-out"},[_vm._v(" Oh, honey, I got a bit carried away daydreaming! Can you try that again, pretty please? ")])
}
var staticRenderFns = []

export { render, staticRenderFns }